import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { loadTextFromFile } from "../loadTextFromFile";

export default function PaperDisplayTextFromFile({dir,fileName}){
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        loadTextFromFile({ dir, fileName })
        .then((text) => {
            if (!cancelled) {
            setContent(text);
            setLoading(false);
            }
        })
        .catch((err) => {
            if (!cancelled) {
            setError(err.message);
            setLoading(false);
            }
        });

        // Cleanup to prevent state updates if component unmounts
        return () => {
        cancelled = true;
        };
    }, [dir, fileName]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;

    return (
    <Paper>
        <Typography 
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              textAlign: "left",
              p: 1,
            }}
        >
            {content}
        </Typography>
    </Paper>
  );
}